import {bool, Schema} from 'simpli-web-sdk'
import CalendarizacaoSla from '@/model/resource/CalendarizacaoSla'

export default (model: CalendarizacaoSla): Schema => ({
  idConfigNovaSlaFk: {
    content: model.$id,
  },
  seg: {
    content: bool(model.seg),
  },
  ter: {
    content: bool(model.ter),
  },
  qua: {
    content: bool(model.qua),
  },
  qui: {
    content: bool(model.qui),
  },
  sex: {
    content: bool(model.sex),
  },
  sab: {
    content: bool(model.sab),
  },
  dom: {
    content: bool(model.dom),
  },
})
